import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { WixIcons } from '../../../../../../components/common';
import { isVideoMediaType } from '../../../../../../utils/mediaType';
import styles from './GalleryItem.scss';
import { IOuter } from './GalleryItem.types';

export const GalleryItem: FC<IOuter> = ({ item, isItemSelected, isItemDisabled, onItemClick, onItemDoubleClick }) => {
  const shouldShowPlayIcon = isVideoMediaType(item.mediaType);

  const handleClick = useCallback(() => onItemClick(item), [onItemClick, item]);
  const handleDoubleClick = useCallback(() => onItemDoubleClick(item), [onItemDoubleClick, item]);

  return (
    <li
      className={classnames(
        styles.item,
        isItemSelected(item.id) && styles.selected,
        isItemDisabled(item) && styles.disabled,
      )}
      style={{ backgroundImage: `url("${item.thumbnailUrl}")` }}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    >
      <div className={styles.inner}>
        <div className={styles.tick}>
          <WixIcons.Check size="34px" />
        </div>
        <div className={classnames(styles.itemName, shouldShowPlayIcon && styles.playIconExists)}>{item.name}</div>
      </div>

      {shouldShowPlayIcon && (
        <div className={styles.playIcon} data-hook="gallery-item-play-icon">
          <WixIcons.PlayFilled size="20px" />
        </div>
      )}
    </li>
  );
};
